import { json, postBiz, rows } from '../core/coreapi';
import { AutoComboResult, ComboOption, ComboValueMode } from './autoCombo.models';

export const normalizeCombo = (r: any): ComboOption => ({
  rid: r.rid ?? r.recid ?? r.id ?? null,
  rix: r.rix ?? r.recix ?? r.ix ?? null,
  shc: r.shc ?? r.shortcode ?? r.code ?? r.nam ?? r.recname ?? '',
  nam: r.nam ?? r.recname ?? r.name ?? r.shc ?? r.shortcode ?? '',
  dsc: r.dsc ?? r.description ?? r.desc ?? '',
  raw: r,
});

export const fetchAutoCombo = async (
  service: string,
  options?: {
    search?: string;
    pageOffset?: number;
    pageLimit?: number;
    action?: string;
    params?: Record<string, any>;
  },
): Promise<AutoComboResult> => {
  const search = options?.search?.trim() || null;
  const pageOffset = Number(options?.pageOffset ?? 0);
  const pageLimit = Number(options?.pageLimit ?? 25);

  const response = await postBiz({
    s: service,
    a: options?.action || 'autocombo',
    ...(options?.params || {}),
    src: search,
    pgo: pageOffset,
    pgl: pageLimit,
  });

  const normalized = rows(response).map(normalizeCombo);
  const payload = json(response) || {};
  const count = Number(payload.rc ?? payload.count ?? payload.total ?? normalized.length);

  return {
    options: normalized,
    count,
    pageOffset,
    pageLimit,
    hasMore: pageOffset + normalized.length < count,
  };
};

export const fetchAutoComboItem = async (
  service: string,
  value: number | string,
  valueMode: ComboValueMode,
  params?: Record<string, any>,
  action = 'comboitem',
): Promise<ComboOption | null> => {
  if (value === null || value === undefined || value === '') return null;

  const response = await postBiz({
    s: service,
    a: action,
    ...(params || {}),
    rid: valueMode === 'id' ? value : null,
    rix: valueMode === 'ix' ? value : null,
    shc: valueMode === 'code' ? value : null,
  });

  const result = rows(response).map(normalizeCombo);
  return result.length ? result[0] : null;
};
